import "./styles.css";

export { RecepcionTraslado } from "./pages/RecepcionTraslado";

export { EnvioTraslados, RecepcionTraslados } from "./pages/ListadoTraslados";

export { ReporteTraslados } from "./pages/ReporteTraslados";

export { CreacionTraslado } from "./pages/CreacionTraslado";

export { SeleccionRecepciones } from "./pages/SeleccionRecepciones";

export { PesajeTraslado } from "./pages/PesajeTraslado";

export { default as BoletaTraslado } from "./pages/BoletaTraslado";
